export const parseAllowedBuildingIds = () => {
  const raw = import.meta.env.VITE_AI_ALLOWED_BUILDING_IDS || ''
  return raw
    .split(',')
    .map((s) => Number.parseInt(s.trim(), 10))
    .filter((n) => Number.isFinite(n) && n > 0)
}

export const isAiBuildingAllowed = (buildingId) => {
  if (!buildingId) return false
  const allowed = parseAllowedBuildingIds()
  if (allowed.length === 0) return false
  return allowed.includes(Number(buildingId))
}

export const adminServiceBaseUrl = import.meta.env.DEV
  ? '/admin-service-proxy'
  : import.meta.env.VITE_ADMIN_SERVICE_API

/** AI endpoints — local admin-service in dev */
export const adminServiceAiBaseUrl = import.meta.env.DEV
  ? '/admin-service-local-proxy'
  : import.meta.env.VITE_ADMIN_SERVICE_API
